module.exports = __webpack_public_path__ + "img/white-swipe.cec68217.svg";